export default {
      id: "emptyAvatar-usage",
      viewBox: "0 0 140 160",
      url: "assets/" + "sprite.svg#emptyAvatar-usage",
      toString: function () {
        return this.url;
      }
    }